import { render, staticRenderFns } from "./InBlockPopUp.vue?vue&type=template&id=a2961862&"
import script from "./InBlockPopUp.vue?vue&type=script&lang=js&"
export * from "./InBlockPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports